import {useListView} from '../../core/ListViewProvider'
import {UsersListToolbar} from './PageListToolbar'
import {PageListGrouping} from './PageListGrouping'
import {PageListSearchComponent} from './PageListSearchComponent'

const PageListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <PageListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <PageListGrouping /> : <UsersListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {PageListHeader}
